import { createUserManager } from "redux-oidc";
import { env } from "utils/env";

const userManagerConfig = {
  client_id: env.REACT_APP_IDENTITY_CLIENT_ID, //'CharismaFinancialServices'
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/callback`,
  response_type: "token id_token",
  scope: "openid profile roles " + env.REACT_APP_IDENTITY_SCOPE, //CSSP.Contracts.read_only
  authority: env.REACT_APP_IDENTITY_AUTHORITY, // 'http://13.81.87.58/'
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/__oidc/silent_renew.html`,
  automaticSilentRenew: true,
  filterProtocolClaims: false,
  loadUserInfo: true,
  revokeAccessTokenOnSignout: true,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/`,
  acr_values: env.REACT_APP_ACR_VALUES,
  checkSessionInterval: 2000
};

console.log("env.REACT_APP_IDENTITY_AUTHORITY: " + env.REACT_APP_IDENTITY_AUTHORITY);

const userManager = createUserManager(userManagerConfig);

export default userManager;
